import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";

class CanBusMachnieryReportStore {
    canBusMachineryReport = [];
    total = 0;
    loading = false;
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            canBusMachineryReport: observable,
            total: observable,
            loading: observable,
            loadData: action,
            exportExcel: action,
            exportpdf: action,
        });
        this.rootStore = rootStore;
    }

    async loadData({ companyId, offset, limit, vehicleId, fromDate, toDate, pageNo }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            vehicleId: vehicleId,
            fromDate: fromDate,
            toDate: toDate,
            offset: offset,
            limit: limit,
            page: pageNo,
        };
        var response = await postApi.getClient('report')
            .post("/tracking_report/canbusmachineryReport", postData);


        this.canBusMachineryReport = response?.data?.data?.canbusMachineryReport;

        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }

    async exportExcel(getData) {
        try {
            var response = await postApi.getClient('report').post("/tracking_report/canbusmachineryReport/download/excel", getData, {
                responseType: "blob",
            });

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Can Bus Machinery Report.xlsx";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }
    }

    async exportpdf(getData) {
        try {
            //http://127.0.0.1:5000/tracking_report/track-data/download/pdf
            var response = await postApi.getClient('report').post("/tracking_report/canbusmachineryReport/download/pdf", getData, {
                responseType: "blob",
            });

            const blob = new Blob([response.data], {
                type: 'application/pdf'
            });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Can Bus Machinery Report.pdf";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            message.error("Failed to download the report. Please try again.")
        }
    }


}

export default CanBusMachnieryReportStore;
